import { Connection } from 'features/connections/types'
import { createDialogOpener } from 'features/dialogs/openDialog'
import { BaseDialogProps } from 'features/dialogs/types'

export const showViewerCredentialsDialog = createDialogOpener(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  () => import('features/connections/ui/ViewerCredentials/ConnectionsCredentialsDialog') as any
)

export const showConnectionCredentialsDialog = createDialogOpener<
  BaseDialogProps & {
    connections: Connection[]
    onResponse?: (result: 'continue' | 'cancel', updatedViewerCredentialsRequired?: Connection[]) => void
    entity?: 'map' | 'workflow'
  }
>(() => import('features/connections/ui/ViewerCredentials/ConnectionsCredentialsDialog'))
